export const AREA_TYPE = {
  BASE: 1,
  SHARE: 2,
  FIELD: 3,
  ACTIVE_FIELD: 4,
  ACTIVE_SHARE: 5,
};
